import React from 'react';
import { Button } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';

export default function ButtonDefault({
  variant,
  size,
  color,
  loading,
  disabled,
  onClick,
  text,
  loadingText,
  ...props
}) {
  return (
    <Button
      variant={variant}
      size={size}
      color={color}
      disabled={disabled || loading}
      onClick={onClick}
      {...props}
      startIcon={loading ? <CircularProgress size="20px" sx={{ color: 'inherit' }} /> : null}
      sx={{
        fontWeight: '550',
        color: 'white',
        textTransform: 'capitalize',
      }}
    >
      {loading ? loadingText || text : text}
    </Button>
  );
}
